import { EnodeHvacZod } from '@vae/server/src/interfaces/eNode/eNodeHVAC.interface'
import { ENodeInverter2 } from '@vae/server/src/interfaces/eNode/eNodeInverter.interface'
import {
	ENodeVehicle,
	EnodeCapabilityList,
} from '@vae/server/src/interfaces/eNode/eNodeVehicle.interface'

export const getInterventionIdsFromVehicle = (vehicle: ENodeVehicle) => [
	...new Set(
		Object.keys(vehicle.capabilities ?? [])
			.map(key => {
				const value = vehicle.capabilities[key as keyof EnodeCapabilityList].interventionIds

				return value
			})
			.flat()
	),
]

export const getInterventionIdsFromList = (vehicles: ENodeVehicle[]) =>
	vehicles.map(vehicle => getInterventionIdsFromVehicle(vehicle)).flat()

export const getInterventionIdsFromHvac = (hvac: EnodeHvacZod) => {
	const interventionIds = {
		setPermanentHold: hvac.capabilities.setPermanentHold.interventionIds,
		setFollowSchedule: hvac.capabilities.setFollowSchedule.interventionIds,
	}

	return interventionIds
}

export const getInterventionIdsFromHvacs = (hvacs: EnodeHvacZod[]) => {
	hvacs.map(hvac => getInterventionIdsFromHvac(hvac)).flat()
}

export const getInterventionsFromInverter = (inverter: ENodeInverter2) => {
	const statisticsInterventions = inverter?.capabilities?.productionStatistics.interventionIds ?? []
	const productionStateInterventions = inverter?.capabilities?.productionState.interventionIds ?? []

	const combined = [...statisticsInterventions, ...productionStateInterventions]
	const unique = Array.from(new Set(combined))

	return unique
}
